export default [
  {
    title: 'Orders',
    icon: 'HomeIcon',
    tagVariant: 'light-warning',
    route: 'dashboard',
  },
]
